/**
 * AI Mockup Generator V2
 * Design Tool UI Match - Fullscreen, clean, professional
 */
export class AIMockupModalV2 {
    constructor() {
        this.modal = null;
        this.centerArea = null;
        this.footerStatus = null;
        this.footerActions = null;
        this.fileInput = null;
        this.productId = 0;
        this.productName = '';
        this.productDesc = '';
        this.variantId = null;
        this.variants = [];
        this.sessionId = null;
        this.regenCount = 0;
        this.mockupImages = [];
        this.selectedQuantity = 100;
        this.currentStep = 'upload';
        // Fun facts rotation
        this.funFactInterval = null;
        this.currentFactIndex = 0;
        this.funFacts = [
            "Did you know? Cannabis has been used medicinally for over 5,000 years!",
            "Fun fact: Hemp can grow up to 15 feet tall in just 3-4 months",
            "The word 'canvas' comes from 'cannabis' - it was made from hemp fiber",
            "George Washington and Thomas Jefferson both grew hemp on their farms",
            "A grinder can increase surface area by up to 300% for better burning",
            "Hemp paper can be recycled up to 7 times (vs. 3 times for wood pulp)",
            "The human body has an endocannabinoid system discovered in the 1990s",
            "Custom products make your brand 70% more memorable to customers",
            "Quality grinders preserve terpenes and flavor profiles better",
            "Your logo + premium products = unforgettable brand experience",
            "Cannabis flowers contain over 100 different cannabinoids",
            "Terpenes give cannabis its unique aromas - from citrus to pine to diesel",
            "The oldest evidence of cannabis use dates back to 10,000 BC in Taiwan",
            "A 4-piece grinder collects kief in the bottom chamber - nature's bonus!",
            "Branded merchandise increases customer loyalty by up to 85%",
            "Zinc grinders stay cool to the touch even after heavy use",
            "The perfect grind: Not too fine, not too chunky - just right",
            "Custom grinders make perfect giveaways at dispensary grand openings",
            "Hemp was the first crop grown in many American colonies",
            "A logo on a grinder = free advertising every time they use it",
            "Grinders with magnetic lids keep your herbs fresh longer",
            "Fun fact: The cannabis plant is actually part of the Cannabaceae family",
            "Sharp grinder teeth = consistent grind = better experience",
            "Branded products create 'walking billboards' for your business",
            "Diamond-cut teeth on grinders can last for years without dulling",
            "Cannabis was legal throughout most of U.S. history until 1937",
            "A personalized grinder shows you care about quality and branding",
            "Aluminum grinders are lightweight but incredibly durable",
            "Custom products turn customers into brand ambassadors",
            "The smell of cannabis comes from terpenes, not cannabinoids",
            "A well-ground herb burns more evenly and efficiently",
            "Your brand on quality products = instant credibility",
            "Hemp fiber is 3x stronger than cotton fiber",
            "Grinders prevent sticky fingers and keep your hands clean",
            "Limited edition branded products create urgency and exclusivity",
            "The first grinder was invented in the 1960s - we've come a long way!",
            "Custom packaging + branded products = premium unboxing experience",
            "Cannabis plants can be male, female, or hermaphrodite",
            "A grinder is the most-used accessory in any smoker's collection",
            "Your logo here = free marketing for life"
        ];
        this.uploadedFile = null;
        console.log('🔧 AIMockupModalV2 constructor called');
        // GATE REMOVED — modal always initializes when the trigger button is on the page.
        this.init();
    }
    init() {
        // Show trigger button
        const trigger = document.querySelector('.ai-mockup-trigger');
        if (trigger) {
            trigger.style.display = 'inline-flex';
            trigger.addEventListener('click', () => {
                // Read data-variant-id at click time so swatch-change variant updates are respected
                const clickVariantId = parseInt(trigger.getAttribute('data-variant-id') || '0');
                if (clickVariantId) {
                    this.variantId = clickVariantId;
                }
                this.open();
            });
        }
        this.modal = document.getElementById('ai-mockup-modal');
        if (!this.modal)
            return;
        // Get product data
        this.productId = parseInt(this.modal.getAttribute('data-product-id') || '0');
        this.productName = this.modal.getAttribute('data-product-name') || '';
        this.productDesc = this.modal.getAttribute('data-product-desc') || '';
        const variantsData = this.modal.getAttribute('data-variants');
        if (variantsData) {
            try {
                this.variants = JSON.parse(variantsData);
                if (this.variants.length > 0) {
                    this.variantId = this.variants[0].id;
                }
            }
            catch (e) {
                console.error('Failed to parse variants:', e);
            }
        }
        this.centerArea = document.getElementById('ai-center-area');
        this.footerStatus = document.getElementById('ai-footer-status');
        this.footerActions = document.getElementById('ai-footer-actions');
        this.fileInput = document.getElementById('ai-file-input');
        this.setupEventListeners();
        this.renderStep('upload');
    }
    setupEventListeners() {
        // Close button
        const closeBtn = document.getElementById('ai-close-btn');
        closeBtn?.addEventListener('click', () => this.close());
        // Variant selects
        const variantOptions = document.getElementById('ai-variant-options');
        if (variantOptions) {
            const selects = variantOptions.querySelectorAll('.ai-option-select');
            selects.forEach(select => {
                select.addEventListener('change', () => this.updateVariant());
            });
        }
        // File input
        if (this.fileInput) {
            this.fileInput.addEventListener('change', (e) => {
                const target = e.target;
                if (target.files && target.files[0]) {
                    this.handleFileSelect(target.files[0]);
                }
            });
        }
    }
    updateVariant() {
        const variantOptions = document.getElementById('ai-variant-options');
        if (!variantOptions)
            return;
        const selectedOptions = [];
        const selects = variantOptions.querySelectorAll('.ai-option-select');
        selects.forEach(select => {
            const selectEl = select;
            selectedOptions.push({
                optionId: parseInt(selectEl.getAttribute('data-option-id') || '0'),
                valueId: parseInt(selectEl.value),
            });
        });
        const matchingVariant = this.variants.find(variant => {
            if (variant.optionValues.length !== selectedOptions.length)
                return false;
            return variant.optionValues.every(optVal => selectedOptions.some(selOpt => selOpt.optionId === optVal.optionId && selOpt.valueId === optVal.valueId));
        });
        if (matchingVariant) {
            this.variantId = matchingVariant.id;
            console.log('✅ Variant matched:', this.variantId);
        }
    }
    open() {
        if (this.modal) {
            this.modal.classList.add('is-open');
            document.body.style.overflow = 'hidden';
        }
    }
    close() {
        if (this.modal) {
            this.modal.classList.remove('is-open');
            document.body.style.overflow = '';
            this.stopFunFacts();
        }
    }
    renderStep(step) {
        this.currentStep = step;
        switch (step) {
            case 'upload':
                this.renderUploadStep();
                break;
            case 'loading':
                this.renderLoadingStep();
                break;
            case 'results':
                this.renderResultsStep();
                break;
            case 'pricing':
                this.renderPricingStep();
                break;
        }
    }
    renderUploadStep() {
        if (!this.centerArea || !this.footerActions)
            return;
        this.centerArea.innerHTML = `
      <div class="ai-upload-zone-v2">
        <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
          <polyline points="17 8 12 3 7 8"/>
          <line x1="12" y1="3" x2="12" y2="15"/>
        </svg>
        <h4>Upload Your Logo</h4>
        <p class="ai-divider">Drag &amp; drop or click to browse</p>
        <button type="button" class="ai-browse-btn-v2" id="ai-browse-trigger">Browse Images</button>
        <small>JPG, PNG (max 10MB)</small>
      </div>
      <div class="ai-input-group">
        <label class="ai-input-label" for="ai-prompt">Describe what you want</label>
        <textarea id="ai-prompt" class="ai-textarea" rows="3"
          placeholder="e.g., Center my logo on the lid, embossed look"
          required></textarea>
      </div>
      <div class="ai-input-group" id="ai-email-group">
        <label class="ai-input-label" for="ai-email">Your email <span class="ai-input-required">*</span></label>
        <input id="ai-email" class="ai-textarea" type="email"
          placeholder="you@example.com"
          autocomplete="email" required />
        <small class="ai-input-hint">We'll send your mockup link here</small>
      </div>
    `;
        // Setup drag & drop
        const uploadZone = this.centerArea.querySelector('.ai-upload-zone-v2');
        if (uploadZone) {
            uploadZone.addEventListener('dragover', (e) => {
                e.preventDefault();
                uploadZone.classList.add('dragover');
            });
            uploadZone.addEventListener('dragleave', () => {
                uploadZone.classList.remove('dragover');
            });
            uploadZone.addEventListener('drop', (e) => {
                e.preventDefault();
                uploadZone.classList.remove('dragover');
                const files = e.dataTransfer?.files;
                if (files && files[0]) {
                    this.handleFileSelect(files[0]);
                }
            });
        }
        // Browse button
        const browseBtn = document.getElementById('ai-browse-trigger');
        browseBtn?.addEventListener('click', () => {
            this.fileInput?.click();
        });
        // Generate button with enable/disable logic
        this.footerActions.innerHTML = `
      <button type="button" class="ai-btn ai-btn-primary" id="ai-generate-btn" disabled>
        Generate Mockup
      </button>
    `;
        const generateBtn = document.getElementById('ai-generate-btn');
        const promptInput = document.getElementById('ai-prompt');
        const emailInput = document.getElementById('ai-email');
        const updateGenerateBtn = () => {
            const hasLogo = !!this.uploadedFile;
            const hasPrompt = !!promptInput?.value?.trim();
            const hasEmail = emailInput ? !!emailInput.value?.trim() : true;
            if (generateBtn)
                generateBtn.disabled = !(hasLogo && hasPrompt && hasEmail);
        };
        promptInput?.addEventListener('input', updateGenerateBtn);
        emailInput?.addEventListener('input', updateGenerateBtn);
        updateGenerateBtn();
        generateBtn?.addEventListener('click', () => {
            if (this.uploadedFile) {
                this.generateMockup(this.uploadedFile);
            }
        });
        if (this.footerStatus)
            this.footerStatus.innerHTML = '';
    }
    renderLoadingStep() {
        if (!this.centerArea)
            return;
        this.centerArea.innerHTML = `
      <div class="ai-loading-overlay">
        <div class="ai-spinner-v2"></div>
        <h3 class="ai-loading-text">Our THC Technology is working...</h3>
        <p class="ai-fun-fact" id="ai-fun-fact-v2">Tool for High-end Customization</p>
      </div>
    `;
        this.startFunFacts();
    }
    renderResultsStep() {
        if (!this.centerArea || !this.footerActions)
            return;
        const latest = this.mockupImages[this.mockupImages.length - 1];
        const regenerationsLeft = Math.max(0, 3 - (this.regenCount ?? 0));
        const exhausted = regenerationsLeft === 0;
        this.centerArea.innerHTML = `
      <div class="ai-result-v2" style="width:100%;max-width:680px;">
        <div class="ai-tile-large">
          ${latest ? `<img src="${latest.url}" alt="Your AI mockup" />` : '<div class="ai-tile-empty">No mockup yet</div>'}
        </div>

        ${exhausted ? this.renderEscalationCardHtml() : ''}

        <div class="ai-feedback-box">
          ${exhausted ? '' : `
            <div class="ai-feedback-label">FEEDBACK</div>
            <textarea id="ai-feedback-text"
              placeholder="Tell us what to change — e.g., 'logo bigger, shifted right, less reflection'"
              rows="3"></textarea>
          `}
          <div class="ai-feedback-row">
            <span class="ai-counter ${exhausted ? 'ai-counter-exhausted' : ''}">
              ${exhausted
            ? 'No regenerations remaining'
            : `<strong>${regenerationsLeft}</strong> of 3 regenerations left`}
            </span>
            ${exhausted ? '' : '<button type="button" class="ai-btn ai-btn-outline" id="ai-regen-btn">↻ Regenerate</button>'}
          </div>
        </div>
      </div>
    `;
        this.footerActions.innerHTML = `
      <button type="button" class="ai-btn ai-btn-primary" id="ai-continue-pricing-btn">
        Use This →
      </button>
    `;
        document.getElementById('ai-continue-pricing-btn')?.addEventListener('click', () => {
            this.renderStep('pricing');
        });
        document.getElementById('ai-regen-btn')?.addEventListener('click', () => {
            const textarea = document.getElementById('ai-feedback-text');
            const feedback = textarea?.value?.trim();
            if (!feedback) {
                alert('Please describe what you want changed');
                return;
            }
            this.regenerate(feedback);
        });
        document.getElementById('ai-escalate-btn')?.addEventListener('click', () => {
            this.handleEscalate();
        });
    }
    renderEscalationCardHtml() {
        return `
      <div class="ai-escalation">
        <div class="ai-escalation-head"><span class="ai-dot"></span>NEED A HUMAN TOUCH?</div>
        <div class="ai-escalation-body">Our studio team will design a custom mockup by hand.</div>
        <div class="ai-escalation-detail">
          We'll send <strong>studio@munchmakers.com</strong> everything you've shared so far —
          your prompt, your logo, and the mockups so far. Most customers hear back within 24 hours.
        </div>
        <button type="button" class="ai-escalation-btn" id="ai-escalate-btn">
          Talk to our studio team →
        </button>
      </div>
    `;
    }
    async handleEscalate() {
        if (!this.sessionId)
            return;
        try {
            const response = await fetch(`/api/ai-mockup/${this.sessionId}/escalate`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: '{}',
            });
            if (response.ok) {
                const data = await response.json();
                this.renderEscalationConfirmation(data.ticketRef);
            }
            else {
                this.renderMailtoFallback();
            }
        }
        catch {
            this.renderMailtoFallback();
        }
    }
    renderEscalationConfirmation(ticketRef) {
        if (!this.centerArea)
            return;
        this.centerArea.innerHTML = `
      <div class="ai-confirmation">
        <h3>You'll hear from us soon</h3>
        <p>Reference <strong>#${ticketRef}</strong>. Our studio team will respond at the email you provided within 24 hours.</p>
      </div>
    `;
        if (this.footerActions)
            this.footerActions.innerHTML = '';
    }
    renderMailtoFallback() {
        const subject = encodeURIComponent('Need help with my AI mockup');
        const body = encodeURIComponent(`Session ${this.sessionId} — could you take a look?`);
        window.location.href = `mailto:studio@munchmakers.com?subject=${subject}&body=${body}`;
    }
    renderThrottleScreen(message) {
        if (!this.centerArea)
            return;
        this.centerArea.innerHTML = `
      <div class="ai-confirmation">
        <h3>One sec</h3>
        <p>${message}</p>
        <button type="button" class="ai-btn ai-btn-primary" id="ai-throttle-mailto-btn">
          Contact our studio team →
        </button>
      </div>
    `;
        if (this.footerActions)
            this.footerActions.innerHTML = '';
        document.getElementById('ai-throttle-mailto-btn')?.addEventListener('click', () => {
            this.renderMailtoFallback();
        });
    }
    async renderPricingStep() {
        // Open pricing modal overlay (like design tool)
        await this.openPricingModal();
    }
    async openPricingModal() {
        const modal = document.getElementById('ai-pricing-modal');
        const modalBody = document.getElementById('ai-pricing-body');
        if (!modal || !modalBody)
            return;
        // Show modal
        modal.style.display = 'flex';
        setTimeout(() => modal.classList.add('is-open'), 10);
        // Show loading
        modalBody.innerHTML = `
      <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 40px; gap: 16px;">
        <div class="ai-spinner-v2"></div>
        <p style="color: #666;">Loading pricing...</p>
      </div>
    `;
        try {
            // Fetch pricing tiers (API returns data directly, not wrapped)
            const response = await fetch(`/api/pricing/${this.productId}/${this.variantId}`);
            if (!response.ok) {
                throw new Error(`API returned ${response.status}`);
            }
            const pricingData = await response.json();
            console.log('📊 Pricing data loaded:', pricingData);
            this.renderPricingModalContent(pricingData);
        }
        catch (error) {
            console.error('Pricing error:', error);
            modalBody.innerHTML = `<p style="color: #f44336; text-align: center;">Failed to load pricing. Please try again.</p>`;
        }
        // Close button
        const closeBtn = modal.querySelector('.ai-pricing-close');
        closeBtn?.addEventListener('click', () => this.closePricingModal());
    }
    closePricingModal() {
        const modal = document.getElementById('ai-pricing-modal');
        if (modal) {
            modal.classList.remove('is-open');
            setTimeout(() => modal.style.display = 'none', 300);
        }
    }
    renderPricingModalContent(pricingData) {
        const modalBody = document.getElementById('ai-pricing-body');
        if (!modalBody)
            return;
        const tiers = pricingData.pricingTiers || [];
        const basePrice = pricingData.basePrice || 35;
        const calculatePrice = (qty) => {
            if (tiers.length === 0) {
                return { unitPrice: basePrice, totalPrice: basePrice * qty, savings: 0 };
            }
            const tier = tiers.find((t) => qty >= t.quantity_min && (!t.quantity_max || qty <= t.quantity_max));
            let unitPrice = basePrice;
            if (tier) {
                if (tier.price_type === 'fixed') {
                    unitPrice = tier.discount_value;
                }
                else if (tier.price_type === 'percent') {
                    unitPrice = basePrice * (1 - tier.discount_value / 100);
                }
                else if (tier.calculated_price) {
                    unitPrice = tier.calculated_price;
                }
            }
            const totalPrice = unitPrice * qty;
            const savings = basePrice > 0 ? ((basePrice - unitPrice) / basePrice) * 100 : 0;
            return { unitPrice, totalPrice, savings };
        };
        const { unitPrice, totalPrice, savings } = calculatePrice(this.selectedQuantity);
        modalBody.innerHTML = `
      ${tiers.length > 0 ? `
      <div class="ai-pricing-table">
        <div class="ai-pricing-table-header">
          <div class="ai-pricing-header-cell">QUANTITY</div>
          <div class="ai-pricing-header-cell">UNIT PRICE</div>
          <div class="ai-pricing-header-cell">YOU SAVE</div>
          <div class="ai-pricing-header-cell">TOTAL</div>
          <div class="ai-pricing-header-cell"></div>
        </div>
        ${tiers.map((tier) => {
            const tierCalc = calculatePrice(tier.quantity_min);
            const isInRange = this.selectedQuantity >= tier.quantity_min && (!tier.quantity_max || this.selectedQuantity <= tier.quantity_max);
            return `
            <div class="ai-pricing-table-row ${isInRange ? 'selected' : ''}" data-qty="${tier.quantity_min}">
              <div class="ai-pricing-cell" data-label="Quantity">
                <div class="ai-pricing-qty">${tier.quantity_min}${tier.quantity_max ? ` - ${tier.quantity_max}` : '+'}</div>
              </div>
              <div class="ai-pricing-cell" data-label="Unit Price">
                <div class="ai-pricing-price">$${tierCalc.unitPrice.toFixed(2)}</div>
              </div>
              <div class="ai-pricing-cell" data-label="You Save">
                ${tierCalc.savings > 0 ? `<span class="ai-pricing-savings">${Math.round(tierCalc.savings)}%</span>` : '<span style="color: #999;">—</span>'}
              </div>
              <div class="ai-pricing-cell" data-label="Total">
                <div class="ai-pricing-total">$${tierCalc.totalPrice.toFixed(2)}</div>
              </div>
              <div class="ai-pricing-cell">
                ${isInRange ? '<span class="ai-pricing-selected-badge">Selected</span>' : ''}
              </div>
            </div>
          `;
        }).join('')}
      </div>
      ` : ''}

      <div class="ai-custom-qty">
        <label class="ai-custom-qty-label">Or enter a custom quantity:</label>
        <div class="ai-custom-qty-controls">
          <input type="number"
                 id="ai-modal-qty-input"
                 class="ai-custom-qty-input"
                 value="${this.selectedQuantity}"
                 min="1" />
          <button type="button" class="ai-qty-btn" id="ai-modal-qty-minus">−</button>
          <button type="button" class="ai-qty-btn" id="ai-modal-qty-plus">+</button>
        </div>
      </div>

      <div class="ai-pricing-summary">
        <div class="ai-summary-row">
          <span class="ai-summary-label">Quantity:</span>
          <span class="ai-summary-value" data-qty-summary>${this.selectedQuantity}</span>
        </div>
        <div class="ai-summary-row">
          <span class="ai-summary-label">Unit Price:</span>
          <span class="ai-summary-value" data-unit-summary>
            $${unitPrice.toFixed(2)}
            ${savings > 0 ? `<span class="ai-savings-badge">save ${Math.round(savings)}%</span>` : ''}
          </span>
        </div>
        <div class="ai-summary-row total-row">
          <span class="ai-summary-label">Total:</span>
          <span class="ai-summary-value total-value" data-total-summary>$${totalPrice.toFixed(2)}</span>
        </div>
      </div>

      <div class="ai-pricing-footer">
        <button type="button" class="ai-btn ai-btn-secondary" id="ai-modal-back-btn">Back to Design</button>
        <button type="button" class="ai-btn ai-btn-primary" id="ai-modal-add-cart-btn">
          Add ${this.selectedQuantity} to Cart
        </button>
      </div>
    `;
        // Event listeners for tier rows
        const tierRows = modalBody.querySelectorAll('.ai-pricing-table-row');
        tierRows.forEach(row => {
            row.addEventListener('click', () => {
                const qty = parseInt(row.getAttribute('data-qty') || '0');
                if (qty > 0) {
                    this.selectedQuantity = qty;
                    this.renderPricingModalContent(pricingData);
                }
            });
        });
        // Quantity controls
        document.getElementById('ai-modal-qty-minus')?.addEventListener('click', () => {
            if (this.selectedQuantity > 1) {
                this.selectedQuantity--;
                this.renderPricingModalContent(pricingData);
            }
        });
        document.getElementById('ai-modal-qty-plus')?.addEventListener('click', () => {
            this.selectedQuantity++;
            this.renderPricingModalContent(pricingData);
        });
        document.getElementById('ai-modal-qty-input')?.addEventListener('change', (e) => {
            const value = parseInt(e.target.value);
            if (value > 0) {
                this.selectedQuantity = value;
                this.renderPricingModalContent(pricingData);
            }
        });
        // Action buttons
        document.getElementById('ai-modal-back-btn')?.addEventListener('click', () => {
            this.closePricingModal();
        });
        document.getElementById('ai-modal-add-cart-btn')?.addEventListener('click', () => {
            this.closePricingModal();
            this.addToCart();
        });
    }
    handleFileSelect(file) {
        if (!file.type.match(/^image\/(png|jpeg|jpg)$/)) {
            alert('Please upload a PNG or JPG file');
            return;
        }
        if (file.size > 10 * 1024 * 1024) {
            alert('File must be under 10MB');
            return;
        }
        if (!this.variantId) {
            alert('Please select product options first');
            return;
        }
        if (this.fileInput) {
            this.fileInput.value = '';
        }
        // Store the file and update the upload zone label
        this.uploadedFile = file;
        const uploadZone = this.centerArea?.querySelector('.ai-upload-zone-v2');
        if (uploadZone) {
            const small = uploadZone.querySelector('small');
            if (small)
                small.textContent = `✓ ${file.name}`;
        }
        // Re-evaluate generate button state
        const generateBtn = document.getElementById('ai-generate-btn');
        const promptInput = document.getElementById('ai-prompt');
        const emailInput = document.getElementById('ai-email');
        const hasPrompt = !!promptInput?.value?.trim();
        const hasEmail = emailInput ? !!emailInput.value?.trim() : true;
        if (generateBtn)
            generateBtn.disabled = !(hasPrompt && hasEmail);
    }
    async generateMockup(file) {
        // Read form values BEFORE renderStep('loading') — that call wipes
        // centerArea.innerHTML and removes the #ai-prompt / #ai-email inputs.
        const promptValue = document.getElementById('ai-prompt')?.value?.trim() || '';
        const emailEl = document.getElementById('ai-email');
        const emailValue = emailEl?.value?.trim() || '';
        this.renderStep('loading');
        const formData = new FormData();
        formData.append('logo', file);
        formData.append('productId', this.productId.toString());
        formData.append('variantId', this.variantId.toString());
        formData.append('prompt', promptValue);
        if (emailValue)
            formData.append('customerEmail', emailValue);
        try {
            const response = await fetch('/api/ai-mockup/generate', {
                method: 'POST',
                body: formData,
            });
            if (response.status === 429) {
                const data = await response.json();
                // EMAIL_THROTTLE and IP_THROTTLE both come with escalationAvailable: 'mailto'.
                // REGEN_LIMIT_REACHED shouldn't fire from /generate (only /regenerate), but defend:
                if (data.error === 'REGEN_LIMIT_REACHED') {
                    // Defensive — surface as throttle screen with same friendly copy.
                    this.stopFunFacts();
                    this.renderThrottleScreen("You've hit the regeneration limit. Drop us a note to keep going.");
                    return;
                }
                const friendlyMsg = data.error === 'EMAIL_THROTTLE'
                    ? "Looks like you've been busy with AI mockups today — drop a note to our studio team to keep things moving."
                    : "Quick break — try again in a few minutes, or contact our studio team.";
                this.stopFunFacts();
                this.renderThrottleScreen(friendlyMsg);
                return;
            }
            const data = await response.json();
            if (!response.ok || !data.sessionId) {
                throw new Error(data.message || 'Failed to start generation');
            }
            this.sessionId = data.sessionId;
            // Always poll — generate returns {sessionId} only, images come from status
            await this.pollForCompletion(this.sessionId);
        }
        catch (error) {
            console.error('Generation error:', error);
            this.renderStep('upload');
            alert(error instanceof Error ? error.message : 'Failed to generate mockup');
        }
    }
    async pollForCompletion(sessionId) {
        const maxAttempts = 30;
        let attempts = 0;
        const poll = async () => {
            attempts++;
            try {
                const response = await fetch(`/api/ai-mockup/status/${sessionId}`);
                const data = await response.json();
                if (data.status === 'ready') {
                    // Adapt new status response shape into the existing mockupImages array
                    if (data.latestMockupUrl) {
                        this.mockupImages = [{
                                url: data.latestMockupUrl,
                                key: data.generations?.[data.generations.length - 1]?.mockupKey || '',
                                order: 0,
                            }];
                    }
                    this.regenCount = data.regenCount ?? 0;
                    this.stopFunFacts();
                    this.renderStep('results');
                    return;
                }
                if (data.status === 'failed') {
                    throw new Error(data.failureReason || 'Generation failed');
                }
                if (data.status === 'generating' && attempts < maxAttempts) {
                    setTimeout(() => poll(), 2000);
                }
                else if (attempts >= maxAttempts) {
                    throw new Error('Generation timed out');
                }
            }
            catch (error) {
                console.error('Polling error:', error);
                this.stopFunFacts();
                this.renderStep('upload');
                alert(error instanceof Error ? error.message : 'Failed to generate mockup');
            }
        };
        await poll();
    }
    async regenerate(feedback) {
        if (!this.sessionId)
            return;
        this.renderStep('loading');
        try {
            const response = await fetch('/api/ai-mockup/regenerate', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    sessionId: this.sessionId,
                    feedback,
                }),
            });
            if (response.status === 429) {
                const data = await response.json();
                if (data.error === 'REGEN_LIMIT_REACHED') {
                    // Update state and re-render results — Task 16's exhausted card will appear.
                    this.regenCount = 3;
                    this.stopFunFacts();
                    this.renderStep('results');
                    return;
                }
                // EMAIL_THROTTLE / IP_THROTTLE → throttle screen with mailto fallback
                const friendlyMsg = data.error === 'EMAIL_THROTTLE'
                    ? "Looks like you've been busy with AI mockups today — drop a note to our studio team to keep things moving."
                    : "Quick break — try again in a few minutes, or contact our studio team.";
                this.stopFunFacts();
                this.renderThrottleScreen(friendlyMsg);
                return;
            }
            const data = await response.json();
            if (!response.ok) {
                throw new Error(data.message || 'Failed to start regeneration');
            }
            // Regenerate returns { sessionId, status: 'generating' } — resume polling
            console.log('⏳ Regeneration started, polling...');
            await this.pollForCompletion(this.sessionId);
        }
        catch (error) {
            console.error('Regeneration error:', error);
            this.stopFunFacts();
            alert(error instanceof Error ? error.message : 'Failed to regenerate');
            this.renderStep('results');
        }
    }
    async addToCart() {
        if (!this.sessionId) {
            alert('No design found');
            return;
        }
        const btn = document.getElementById('ai-modal-add-cart-btn');
        if (btn) {
            btn.disabled = true;
            btn.textContent = 'Adding...';
        }
        try {
            const response = await fetch('/api/ai-mockup/add-to-cart', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    sessionId: this.sessionId,
                    quantity: this.selectedQuantity,
                }),
            });
            const data = await response.json();
            if (!response.ok || !data.success) {
                throw new Error(data.message || 'Failed to add to cart');
            }
            // data.designId is the new Design row id (NOT sessionId) — used for future reference
            console.log('✅ Added to cart. designId:', data.designId, 'cartItemId:', data.cartItemId);
            // Update cart count (fallback: increment by 1 if no count returned)
            const cartCount = document.querySelector('[data-cart-count]');
            if (cartCount) {
                const newCount = parseInt(cartCount.textContent || '0') + 1;
                cartCount.textContent = newCount.toString();
            }
            alert('Added to cart!');
            this.close();
            setTimeout(() => {
                window.location.href = '/cart';
            }, 500);
        }
        catch (error) {
            console.error('Add to cart error:', error);
            alert(error instanceof Error ? error.message : 'Failed to add to cart');
            if (btn) {
                btn.disabled = false;
                btn.textContent = `Add ${this.selectedQuantity} to Cart`;
            }
        }
    }
    async requestManual(message) {
        if (!this.sessionId)
            return;
        try {
            const response = await fetch('/api/ai-mockup/request-manual', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    designId: this.sessionId,
                    message,
                }),
            });
            const data = await response.json();
            if (data.success) {
                alert(data.message || 'Request submitted!');
                this.close();
            }
            else {
                throw new Error(data.message || 'Failed to submit request');
            }
        }
        catch (error) {
            console.error('Manual request error:', error);
            alert(error instanceof Error ? error.message : 'Failed to submit request');
        }
    }
    // Fun Facts
    startFunFacts() {
        this.currentFactIndex = 0;
        this.showFunFact();
        this.funFactInterval = window.setInterval(() => {
            this.currentFactIndex = (this.currentFactIndex + 1) % this.funFacts.length;
            this.showFunFact();
        }, 3000);
    }
    showFunFact() {
        const factEl = document.getElementById('ai-fun-fact-v2');
        if (factEl) {
            factEl.style.opacity = '0';
            setTimeout(() => {
                factEl.textContent = this.funFacts[this.currentFactIndex];
                factEl.style.opacity = '1';
            }, 300);
        }
    }
    stopFunFacts() {
        if (this.funFactInterval) {
            clearInterval(this.funFactInterval);
            this.funFactInterval = null;
        }
    }
}
// Initialize
document.addEventListener('DOMContentLoaded', () => {
    // This will be called from app.ts instead
});
